
    <div class="banner__action mt-2" [routerLink]="[]">
        <h5 >{{title}} <span class="rounded-circle">5</span> </h5>
        
        <p>{{explanatoryText}}<p>
    </div>

    <!-- <div class="banner__action mt-2" [routerLink]="">
        <h5>Listado de solicitudes a aprobar <span class="rounded-circle">5</span></h5>
        <p>Nuevas, renovaciones y ampliaciones.
            <p>
    </div> -->

